module.exports = __webpack_public_path__ + "static/img/reminder.56fcd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharing/reminder.png
// module id = o+NN
// module chunks = 43